import '@splidejs/react-splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useMediaQueries } from '@hooks';
import Image from 'next/image';
import React from 'react';

const Sponsors = ({ sponsors = [] }) => {
  const repeatedSponsors = [...sponsors, ...sponsors]; //to be able to fill the whole page
  const { isMobile } = useMediaQueries();
  return (
    <div>
      <Splide
        options={{
          type: 'loop',
          drag: 'free',
          focus: 'center',
          perPage: isMobile ? 4 : 8,
          gap: '1rem',
          arrows: false,
          pagination: false,
          lazyLoad: 'nearby',
          autoScroll: {
            speed: 0.7,
          },
        }}
        extensions={{ AutoScroll }}
      >
        {repeatedSponsors.map((sponsor, index) => {
          const { img, id, slug } = sponsor;
          return (
            <SplideSlide key={`${id}-${index}`}>
              <div className="h-20 md:h-12">
                <Image
                  src={img?.data?.attributes?.url}
                  alt={slug}
                  fill
                  className="relative object-contain  "
                />
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
    </div>
  );
};

export default Sponsors;
